export const bytesToGBString = (bytes?: bigint): string => {
  if (!bytes) return "0 GB";
  return `${Math.round(Number(bytes) / 1024 ** 3)} GB`;
};
